module.exports = __webpack_public_path__ + "static/media/table16.6a3a76e3.svg";